import {
  GET_BUSSINESS_DASHBOARD_CUSTOMER_WISE_REQUEST,
  GET_BUSSINESS_DASHBOARD_CUSTOMER_WISE_SUCCESS,
  GET_BUSSINESS_DASHBOARD_CUSTOMER_WISE_ERROR
  } from "../actions/types";
  
  export const bussinessDashboardCustomerWise = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_BUSSINESS_DASHBOARD_CUSTOMER_WISE_REQUEST:
        return {
          loading: true,
        };
      case GET_BUSSINESS_DASHBOARD_CUSTOMER_WISE_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_BUSSINESS_DASHBOARD_CUSTOMER_WISE_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  